import { AttackPointAttribute } from '@collector/sportsapi-client-legacy'

export const zones = new Map<number, AttackPointAttribute>([
  [1, AttackPointAttribute.Zone1],
  [2, AttackPointAttribute.Zone2],
  [3, AttackPointAttribute.Zone3],
  [4, AttackPointAttribute.Zone4],
  [5, AttackPointAttribute.Zone5],
  [6, AttackPointAttribute.Zone6],
])
